import { scoreWithKeypoint } from './utils/tfjsTools';

const poseX = 1;
const poseY = 1;

const color = '#99FC23';

// --- 1 Euro Filter Implementation ---
class OneEuroFilter {
  constructor(minCutoff = 1.0, beta = 0.001, dCutoff = 1.0) {
    this.minCutoff = minCutoff;
    this.beta = beta;
    this.dCutoff = dCutoff;
    this.xPrev = null;
    this.dxPrev = null;
    this.tPrev = null;
  }

  alpha(dt, cutoff) {
    const tau = 1.0 / (2 * Math.PI * cutoff);
    return 1.0 / (1.0 + tau / dt);
  }

  filter(x, t) {
    if (this.tPrev === null) {
      this.xPrev = x;
      this.dxPrev = 0;
      this.tPrev = t;
      return x;
    }
    const dt = (t - this.tPrev) / 1000.0;
    if (dt <= 0) return x;
    const dx = (x - this.xPrev) / dt;
    const edx =
      this.alpha(dt, this.dCutoff) * dx +
      (1 - this.alpha(dt, this.dCutoff)) * this.dxPrev;
    const cutoff = this.minCutoff + this.beta * Math.abs(edx);
    const a = this.alpha(dt, cutoff);
    const xFiltered = a * x + (1 - a) * this.xPrev;
    this.xPrev = xFiltered;
    this.dxPrev = edx;
    this.tPrev = t;
    return xFiltered;
  }

  reset() {
    this.xPrev = null;
    this.dxPrev = null;
    this.tPrev = null;
  }
}

class OneEuroFilter2D {
  constructor(minCutoff = 0.5, beta = 0.01, dCutoff = 1.0) {
    this.xFilter = new OneEuroFilter(minCutoff, beta, dCutoff);
    this.yFilter = new OneEuroFilter(minCutoff, beta, dCutoff);
  }
  filter(x, y, t) {
    return {
      x: this.xFilter.filter(x, t),
      y: this.yFilter.filter(y, t),
    };
  }
  reset() {
    this.xFilter.reset();
    this.yFilter.reset();
  }
}

let keypointFilters = [];

export const resetMatchmanFilters = () => {
  keypointFilters = [];
};
// ------------------------------------

/**
 * 绘制火柴人
 */
export const drawPerson = (canvasCtx, person) => {
  if (!canvasCtx || !person) {
    console.warn('drawPerson... para error');
    return;
  }

  if (keypointFilters.length === 0) {
    for (let i = 0; i < 17; i++) {
      // 调整 minCutoff (降低可减少低速抖动) 和 beta (增加可减少高速延迟)
      // 将 minCutoff 从 0.5 降到 0.05，大幅抑制低速下的微小抖动
      // 将 beta 从 0.02 降到 0.005，使得即使在动作稍快时也保持一定的平滑度
      keypointFilters.push(new OneEuroFilter2D(0.05, 0.005, 1.0));
    }
  }

  const t = performance.now();
  let pose = person.keypoints.map((kp, i) => {
    if (scoreWithKeypoint(person.keypoints, i)) {
      const smoothed = keypointFilters[i].filter(kp.x, kp.y, t);
      return { ...kp, x: smoothed.x, y: smoothed.y };
    } else {
      keypointFilters[i].reset();
      return kp;
    }
  });

  const ctx = canvasCtx;

  // console.log('draw pose', pose)

  // 绘制火柴人
  let headArc = 14;
  let pointArc = 6;
  ctx.beginPath();
  ctx.lineWidth = 5;
  ctx.strokeStyle = color;

  //0 鼻子
  //1 左眼
  //2 右眼
  //3 左耳
  //4 右耳
  //5 左肩
  //6 右肩
  //7 左肘
  //8 右肘
  //9 左腕
  //10 右腕
  //11 左胯
  //12 右胯
  //13 左膝
  //14 右膝
  //15 左脚
  // 16 右脚

  // 计算头部的中心点（利用双耳的中心作为头部中心更为合理）
  const leftEar = pose[3];
  const rightEar = pose[4];
  const nose = pose[0];
  let headCenter = { x: 0, y: 0 };
  let headValid = false;

  if (scoreWithKeypoint(pose, 3) && scoreWithKeypoint(pose, 4)) {
    headCenter = {
      x: (leftEar.x + rightEar.x) / 2,
      y: (leftEar.y + rightEar.y) / 2,
    };
    headValid = true;
  } else if (scoreWithKeypoint(pose, 0)) {
    // 如果没有耳朵数据，就退而求其次用鼻子作为中心（可稍微向上偏移一点作为头部中心）
    headCenter = {
      x: nose.x,
      y: nose.y - 10,
    };
    headValid = true;
  }

  if (headValid) {
    // 绘制头部
    ctx.arc(
      headCenter.x * poseX,
      headCenter.y * poseY,
      headArc,
      0,
      Math.PI * 2,
    );
    ctx.fillStyle = color;
    ctx.fill();
    ctx.stroke();
  }

  // 绘制身体
  const nick = {
    x: (pose[5].x + pose[6].x) / 2,
    y: (pose[5].y + pose[6].y) / 2,
  };
  const hip = {
    x: (pose[11].x + pose[12].x) / 2,
    y: (pose[11].y + pose[12].y) / 2,
  };

  if (headValid) {
    ctx.beginPath();
    ctx.moveTo(headCenter.x * poseX, headCenter.y * poseY);
    ctx.lineTo(nick.x * poseX, nick.y * poseY);
    ctx.stroke();
    ctx.closePath();
  }

  const neckLeft = pose[5]; //5 左肩
  const hipLeft = pose[11]; //11 左胯
  const neckRight = pose[6]; //6 右肩
  const hipRight = pose[12]; //12 右胯
  ctx.beginPath();
  ctx.moveTo(nick.x * poseX, nick.y * poseY);
  ctx.lineTo(hip.x * poseX, hip.y * poseY);
  ctx.closePath();
  ctx.stroke();

  if (scoreWithKeypoint(pose, 5) && scoreWithKeypoint(pose, 6)) {
    ctxWithPoint(ctx, nick, pointArc, neckLeft);
    ctxWithPoint(ctx, nick, pointArc, neckRight);
  }
  if (scoreWithKeypoint(pose, 11) && scoreWithKeypoint(pose, 12)) {
    ctxWithPoint(ctx, hip, pointArc, hipLeft);
    ctxWithPoint(ctx, hip, pointArc, hipRight);
  }

  // 绘制左臂
  ctx.beginPath();
  const leftElbow = pose[7]; // 左肘
  const handLeft = pose[9]; // 左腕
  if (scoreWithKeypoint(pose, 5) && scoreWithKeypoint(pose, 7)) {
    ctxWithPoint(ctx, neckLeft, pointArc, leftElbow);
  }
  if (scoreWithKeypoint(pose, 7) && scoreWithKeypoint(pose, 9)) {
    ctxWithPoint(ctx, leftElbow, pointArc, handLeft);
  }
  if (scoreWithKeypoint(pose, 9)) {
    ctxWithPoint(ctx, handLeft, pointArc);
  }

  // 绘制右臂
  const rightElbow = pose[8]; // 右肘
  const handRight = pose[10]; // 右腕
  if (scoreWithKeypoint(pose, 6) && scoreWithKeypoint(pose, 8)) {
    ctxWithPoint(ctx, neckRight, pointArc, rightElbow);
  }
  if (scoreWithKeypoint(pose, 8) && scoreWithKeypoint(pose, 10)) {
    ctxWithPoint(ctx, rightElbow, pointArc, handRight);
  }
  if (scoreWithKeypoint(pose, 10)) {
    ctxWithPoint(ctx, handRight, pointArc);
  }

  // 绘制左腿
  const leftKnee = pose[13]; // 左膝
  const leftFoot = pose[15]; // 左脚
  if (scoreWithKeypoint(pose, 11) && scoreWithKeypoint(pose, 13)) {
    ctxWithPoint(ctx, hipLeft, pointArc, leftKnee);
  }
  if (scoreWithKeypoint(pose, 13) && scoreWithKeypoint(pose, 15)) {
    ctxWithPoint(ctx, leftKnee, pointArc, leftFoot);
  }
  if (scoreWithKeypoint(pose, 15)) {
    ctxWithPoint(ctx, leftFoot, pointArc);
  }

  // 绘制右腿
  const rightKnee = pose[14]; // 右膝
  const rightFoot = pose[16]; // 右脚
  if (scoreWithKeypoint(pose, 12) && scoreWithKeypoint(pose, 14)) {
    ctxWithPoint(ctx, hipRight, pointArc, rightKnee);
  }
  if (scoreWithKeypoint(pose, 14) && scoreWithKeypoint(pose, 16)) {
    ctxWithPoint(ctx, rightKnee, pointArc, rightFoot);
  }
  if (scoreWithKeypoint(pose, 16)) {
    ctxWithPoint(ctx, rightFoot, pointArc);
  }

  ctx.stroke();
};
/**
 * canvas单点绘制封装
 */
const ctxWithPoint = (ctx, point, width, nextPoint) => {
  if (nextPoint) {
    ctx.beginPath();
    ctx.strokeStyle = color;
    ctx.moveTo(point.x * poseX, point.y * poseY);
    ctx.lineTo(nextPoint.x * poseX, nextPoint.y * poseY);
    ctx.stroke();
    ctx.closePath();
  }
  ctx.beginPath();
  ctx.strokeStyle = color;
  ctx.arc(point.x * poseX, point.y * poseY, width, 0, Math.PI * 2);
  ctx.fillStyle = color;
  ctx.fill();
  ctx.stroke();
  ctx.closePath();
};
